import wj from '@/plugins/wjtools'
// import * as api from '@/api'

// 登陆
export const login = ({ commit }, payload) => {
  commit('setToken', payload.token)
  commit('setUser', payload.user)
  wj.session('user', {
    user: payload.user,
    token: payload.token,
    loginStatistical: 'active' // 登录次数标记（关闭浏览器重新进入，登录状态没有失效，不需要走登录接口）
  }, 86400)
}
